module.exports = __webpack_public_path__ + "ionicons.2c159d0d05473040b53e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.woff?v=2.0.1
// module id = 581
// module chunks = 10